import { CrudModule } from "@/command/ccCrud";

export default function Contracts() {
  return (
    <CrudModule
      title="Contracts" subtitle="Vendor & client contracts with renewal alerts — live."
      module="contracts" endpoint="/cc/contracts" entity="contract" summaryPath="/cc/contracts/summary"
      columns={[["title", "Contract"], ["party", "Party"], ["type", "Type", "badge"], ["value", "Value", "money"], ["renewal_date", "Renews"], ["status", "Status", "badge"]]}
      fields={[["title", "Title", "text"], ["party", "Party", "text"], ["type", "Type", "select", ["Vendor", "Client", "Partner"]],
        ["value", "Value (₹)", "number"], ["start_date", "Start date", "date"], ["renewal_date", "Renewal date", "date"],
        ["status", "Status", "select", ["Active", "Renewed", "Expired"]], ["notes", "Notes", "text"]]}
      defaults={{ status: "Active", type: "Vendor" }}
      kpis={(rows, s) => [
        { label: "Contracts", value: s?.total ?? rows.length },
        { label: "Active", value: s?.active ?? 0 },
        { label: "Renewing Soon", value: s?.renewing_soon ?? 0 },
        { label: "Expired", value: s?.expired ?? 0 },
      ]}
    />
  );
}
